module.exports = __webpack_public_path__ + "h5/img/gift.bde2a03c.png";